/**
 * The following translations must be added to en.json.
 * Find the top-level object for each and add newly created ones.
 *
 * Then ensure the parent object is subscribed to in the CommonService.
 */

export const readyTranslations = {
  dashboard: {
    Overview: 'Overview',
    Home: 'Home',
    'Main Dashboard': 'Main Dashboard',
  },

  messagesAndWarnings: {
    noResultsFound: 'No Results Found',
    failedToFetchData: 'Failed to fetch data',
    failedToProcessData: 'Failed to process data',
    requestProcessed: 'Request processed',
    failedToProcessRequest: 'Failed to process request',
    keepAliveFailed: 'Keep-alive Failed',
    deletionFailed: 'Failed to Delete',
    refreshAndTryAgain: 'Refresh and try again',
    passwordResetRequired:
      'You must reset your password before you can continue. An email has been sent to your registered email address.',
    passwordSuccessfullyChanged: 'Password successfully changed',
    invalidPassword: 'Invalid new password',
    signInFailed: 'Sign-In Failed . Check credentials',
    signInFailedMultipleComapny: 'Sign-In Failed. Please provide company code.',
    passwordResetRequestFailed: 'Password reset request failed . Refresh and try again',
    passwordResetRequestFailedMultipleCompany: 'Password reset request failed . Prease provide company code.',
    ifProblemPersistsContact: 'If problem persists contact',
    passwordResetSuccessfullyRequested:
      'Password reset successfully requested . Check your email to complete the process',
    checkEmailToComplete: 'Check your email to complete the process',
    unableToValidateSecurityRequest: 'Unable to validate security request . Try the process again.',
    uploadCsvFile: 'Please import valid .csv file',
    functionalityNotAvailable: 'Functionality not available',
    insufficientPermissionToViewRequestedPage: 'You have insufficient permission to view the requested page',
    pressSubmitToSave: 'Press submit to save',
    working: 'Working...',
    genericError: 'Something went wrong',
    activationMailSuccess: 'Activation email sent.',
    activationMailFailed: 'Failed to send.',
    activationBulkMailSuccess: 'Bulk activation email sent successfully.',
    activationBulkMailFailed: 'Bulk email failed to send.',
    unauthorized: 'Access denied',
    checkCredentials: 'Please ensure you have entered existing credentials correctly',
    tryAgainIn: 'Try again in: ',
    formatNotSupported: 'The format in use is not supported',
    failedToSwitchToTheSelectedCompany: 'Failed to switch to the selected company',
    fileMayNotWorkCorrectly: 'This file may not download or work correctly',
    requestedAssetNotAvailable: 'Requested asset not available',
    landingPageNotFound: 'Landing page not found',
    mvrOrdered: 'MVR ORDER REQUEST SENT',
    hasMvrInformationSuggestion: 'Sufficient information to order an MVR',
    noValidDriverLicenseSuggestion: 'Valid driver license information',
    pendingMvrOrderSuggestion: 'No pending MVR order',
    invalidUserInfo: 'Invalid user information.',
    invalidStations: 'Station(s) not found.',
    invalidCsvRow: 'Invalid row entry in the CSV.',
    uploadErrorGeneral:
      "Errors found while uploading.Please check error below then click on 'Continue' button to try again.",
    passwordResetLinkExpired: 'This password reset link has expired. Please try again.',
    passwordResetFailed:
      'The password does not meet the password policy requirements. Please check the password requirements as displayed on this page.',
    errorAssigningCoaching: 'Error while assigning coaching.',
    dashboardNotFound: 'Dashboard not found.',
    inProgress: 'In progress',
    passwordMismatch: 'Password mismatch',
    checkingUpdates: 'Checking updates',
    exportingData: 'Exporting data',
    downloadingAndProcessingExport: 'Downloading and processing data export',
    pleaseWait: 'Please wait',
    unableToCalculate: 'Unable to calculate',
    unableToFullyCalculate: 'Unable to calculate',
    unableToCalculateReasonDriverChangedFromDistanceToOdometerReading:
      'The data provided does not allow a total distance travelled to be calculated. This could be because the driver changed the reporting type from Total Distance to Odometer between reporting month',
    unableToCalculateReasonPossibleInconsistentReadingSubmitted:
      'The difference between the reported distance travelled from this period and the last period cannot be calculated based on the provided data. This could be because a reading for one or more month was not submitted or the readings submitted were not consistent.',
    unableToCalculateReasonTotalDistanceOnlyIncludesReported:
      'The total distance travelled only includes data reported.',
  },

  generic: {
    view: 'View',
    theseDrivers: 'These Drivers',
    companyAverage: 'Company Average',
    send: 'Send',
    sendGuide: 'Send Guide',
    fullInformation: 'Full Information',
    riskRating: 'Risk Rating',
    areaOfFocus: 'Area of Focus',
    select: 'Select',
    selectAll: 'Select All',
    unselectAll: 'Unselect All',
    search: 'Search',
    exitSearch: 'Exit search',
    refresh: 'Refresh',
    reloading: 'Reloading',
    ok: 'OK',
    close: 'close',
    cancel: 'Cancel',
    bookmark: 'Bookmark',
    reportState: 'Report state',
    createNewOneToOne: 'Create New One To One Coaching Session',
    createNewPccReview: 'Create New Post Collision Coaching Session',
    createNewDriverIndexCoach: 'Create New DriverINDEX Coaching Session',
    createNewDriverIndexProCoach: 'Create New DriverINDEX Coach - ProCOACH Session',
    createNewVirtualSafetyDiscussion: 'Create New Virtual Safety Discussion Session',
    day: 'Day',
    week: 'Week',
    month: 'Month',
    year: 'Year',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    yearly: 'Yearly',
    jan: 'Jan',
    feb: 'Feb',
    mar: 'Mar',
    apr: 'Apr',
    may: 'May',
    jun: 'Jun',
    jul: 'Jul',
    aug: 'Aug',
    sept: 'Sept',
    sep: 'Sept',
    oct: 'Oct',
    nov: 'Nov',
    dec: 'Dec',
    readonlyView: 'Read-only view',
    print: 'Print',
    orderMvr: 'Order MVR',
    driver: 'Driver',
    license: 'License',
    note: 'Note',
    created: 'Created',
    description: 'Description',
    acknowledgement: 'Acknowledgement',
    update: 'Update',
    details: 'Details',
    mentorPlaylist: 'Mentor Playlist',
    assigned: 'Assigned',
    noMentorPlaylistModules: 'No Modules Found',
    up: 'Up',
    down: 'Down',
    notApplicable: 'N/A',
    viewDetails: 'View Details',
    generatedOn: 'Generated on',
    authorised: 'Authorised',
    notAuthorised: 'Not Authorised',
    resetGridState: 'Reset Preferences',
    fullError: 'Full Error',
    done: 'Done',
    uploadElements: 'UPLOAD NEW USERS',
    riskInsights: 'Risk Insights',
    otherRiskFactors: 'Other Risk Factors',
    suggestedAction: 'Suggested Action',
    bestPracticeGuide: 'Best Practice Guide',
    atRiskDrivers: 'At-Risk Drivers',
    sendPdfToAtRiskDrivers: 'Send PDF to all At-Risk Drivers',
    vrmNotification: 'VRM Notification',
    driversAssigned: 'Drivers Assigned',
    driversCompleted: 'Drivers Completed',
  },

  form: {
    required: 'Required',
    invalidEmail: 'Enter a valid email',
    mustMatch: 'must match',
    invalid: 'is invalid',
    failedToSaveFormData: 'Failed to save Form data',
    formSaved: 'Form Saved',
    driverPerformanceRecord: 'Driver Record',
    driverPerformanceRecord_Non_Amazon: 'Driver Performance Record',
    oneToOnePlus: 'OneToOne+',
    postCollisionCrash: 'Post Collision Crash',
    driverIndexCoachReview: 'DriverINDEX Coach Review',
    saveCurrentProgress: 'Save Current Progress',
    cancel: 'Cancel',
    markSessionAsComplete: 'Mark Session as Complete?',
    completeAllRequiredFields: 'Please complete all required fields',
    coachingSessionWillNoMoreBeEditable: 'This coaching session will no more be editable once confirmed as complete',
    pressCompleteToConfirm: 'Press the Complete button to confirm',
    coachingCanOnlyBeMarkedCompleteIfRequiredFilled:
      'Coaching can only be marked as complete if all required fields have been completed',

    clickContinueToConfirmDerCompletion:
      "Clicking 'Continue' will complete your review of this report and you will be unable to make further edits.",
    derCanOnlyBeMarkedCompleteIfRequiredFilled:
      'The Driver Event Report (DER) Review can only be marked as complete if all required questions have been completed.',
    continue: 'Continue',

    retry: 'Retry',
    yes: 'Yes',
    no: 'No',
    emailAddress: 'Email Address',
    number: 'must contain a number',
    uppercaseLetter: 'must contain at least one uppercase letter',
    lowercaseLetter: 'must contain at least one lowercase letter',
    specialCharacter: 'must contain at least one valid special character',
    minlength: 'must contain at least',
    maxlength: 'must contain a maximum of',
    characters: 'characters',
    submit: 'Submit',
    'Post Collision Coaching': 'Post Collision Coaching',
    'Virtual Safety Discussion': 'Virtual Safety Discussion',
    confirm: 'Confirm',
    failedToFetchCoachFormData: 'Failed to fetch Coach Form data',
    OneToOne: 'OneToOne',
    PccReview: 'Post Collision Coaching',
    DriverImprovementReview: 'DriverINDEX Coach',
    PccProCoach: 'Pro Coach',
    DriverIndexProCoach: 'DriverINDEX Coach - ProCOACH',
    OneToOneProCoach: 'OneToOne PRO Coach',
    PccReviewProCoach: 'Post Collision PRO Coaching',
    OneWeekFICO_LT500: '1 Week FICO® <500',
    TwoWeeksFICO_LT710: '2 Weeks FICO® <710',
    VirtualSafetyDiscussion: 'Virtual Safety Discussion',
    clearButton: 'Clear',
  },
  user: {
    firstNameLabel: 'First Name',
    middleNameLabel: 'Middle Name',
    lastNameLabel: 'Last Name',
    phoneNumberLabel: 'Phone Number',
    eMailLabel: 'Email Address',
    driver: 'Driver',
    manager: 'Manager',
    driverSelect: 'Select station to drive',
    managerSelect: 'Select station to manage',
    successMessage: 'User successfully created',
    successUpdateMessage: 'User successfully saved',
    confirmDeleteMessage: 'Deleting user cannot be undone. Do you really want to delete the user?',
    successDeleteMessage: 'User successfully deleted',
    retryDeleteMessage: 'Please try again',
    failedDeleteMessage: 'User deletion failed',
    uploadUsersButton: 'Choose your csv file for upload',
    downloadTemplateButton: 'Download csv template',
    uploadInvalidRow: 'Invalid',
    uploadValidRow: 'Valid',
    uploadLosedRow: 'Lost',
    uploadSubmit: 'Upload valid users',
    userExists: 'User already exists',
    GroupDataUpdateFailed: 'Groups data failed to save',
    UserDataUpdateFailed: 'User data failed to save',
    uploadContinue: 'Continue',
    formatToCsvTemplate: 'In Order to upload users, you must format the data using our CSV template.',
    downloadOnRight: 'You can download it on the right.',
    saveAndUploadFile: 'Once you have entered your data into this template,save it and upload the file below.',
    verifyAfterUpload:
      'After the data uploads, you will have an opportunity to verify and edit it before adding the new user accounts.',
    uploadingStatus: 'Uploading',
    uploadingStatusTo: 'to',
    uploadingStatusOutOf: 'out of ',
    uploadingStatusRecords: 'records.',
    uploadResultSubject: 'User/s',
    uploadResultTitle: 'Upload users result',
    updateUser: 'Update User',
    createUser: 'Create User',
    deleteUser: 'Delete User',
    sendBatchActivationEmail: 'SEND BATCH ACTIVATION EMAILS',
    usernameOrEmailExists: 'User name or email exists',
    usernameExists: 'User name exists',
    emailExists: 'Email exists',
    unknownServerError: 'Server Error. Please retry.',
    invalidEntry: 'Invalid Data Entry.',
    invalidEmail: 'Invalid Email',
    stationAssignmentForMultiple: 'Scheduled Assignment for Users',
  },
  reportColumns: {
    'Driver Rating': 'Driver Rating',
    'Journey Rating': 'Journey Rating',
    'Vehicle Rating': 'Vehicle Rating',
  },
  reportData: {
    initial: 'INITIAL',
    recheck: 'RECHECK',
    're-check': 'RE-CHECK',

    safeDriver: 'Safe Driver',
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    veryHigh: 'Very High',

    active: 'Active',
    inactive: 'Inactive',
    pending: 'Pending',
    suppressed: 'Suppressed',
    archive: 'Archive',
    other: 'Other',
    preHire: 'Pre Hire',

    agree: 'Agree',
    disagree: 'Disagree',
    hold: 'Hold',
    testAccount: 'Test Account',

    required: 'Required',
    notRequired: 'Not Required',
    optional: 'Optional',
    current: 'Current',

    complete: 'Complete',
    incomplete: 'Incomplete',
    inProgress: 'In progress',
    notStarted: 'Not Started',
    overdue: 'Overdue',
    noCoursesAssigned: 'No Courses Assigned',
    closed: 'Closed',
    partial: 'Partial',
    na: 'N/A',

    great: 'Great',
    good: 'Good',
    average: 'Average',
    poor: 'Poor',
    risky: 'Risky',

    veryLowRisk: 'Very Low Risk',
    lowRisk: 'Low Risk',
    mediumRisk: 'Medium Risk',
    highRisk: 'High Risk',
    veryHighRisk: 'Very High Risk',
    noData: 'No Data',

    yes: 'Yes',
    no: 'No',
    valid: 'Valid',
    notValid: 'Not Valid',
    seeMvr: 'See MVR',
    seeLicenceCheck: 'See Licence Check',
    found: 'Found',

    playlistItem: 'Playlist Item',
    dateAssigned: 'Date Assigned',
    dateCompleted: 'Date Completed',
    status: 'Status',
    benchmark: 'BENCHMARK',
    allStations: 'All Stations',

    overDue: 'Overdue',

    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',

    'Select to View': 'Select to View',
    'Select to Launch': 'Select to Launch',

    Car: 'Car',
    'SUV / 4x4': 'SUV / 4x4',
    Van: 'Van',
    Motorbike: 'Motorbike',
    Bicycle: 'Bicycle',
    'Large Vehicle (Multi-Drop)': 'Large Vehicle (Multi-Drop)',
    'Tractor Trailer': 'Tractor Trailer',
    'Large Vehicle (Straight)': 'Large Vehicle (Straight)',

    None: 'None',
    Slight: 'Slight',
    Serious: 'Serious',
    Fatal: 'Fatal',

    'Driver: Distraction': 'Driver: Distraction',
    'Driver: Lack of Observation': 'Driver: Lack of Observation',
    'Driver: Fatigue': 'Driver: Fatigue',
    'Driver: Excessive Speed': 'Driver: Excessive Speed',
    'Driver: Lack of Experience / Knowledge / Skill': 'Driver: Lack of Experience / Knowledge / Skill',
    'Driver: Driving too Close': 'Driver: Driving too Close',
    'Driver: Failure to Yield': 'Driver: Failure to Yield',
    'Driver: DUI Alcohol / Drugs / Medication': 'Driver: DUI Alcohol / Drugs / Medication',
    'Driver: Emotional Breakdown / Road Rage': 'Driver: Emotional Breakdown / Road Rage',
    'Other Party: Distraction': 'Other Party: Distraction',
    'Other Party: Lack of Observation': 'Other Party: Lack of Observation',
    'Other Party: Fatigue': 'Other Party: Fatigue',
    'Other Party: Excessive Speed': 'Other Party: Excessive Speed',
    'Other Party: Lack of Experience / Knowledge / Skill': 'Other Party: Lack of Experience / Knowledge / Skill',
    'Other Party: Driving too Close': 'Other Party: Driving too Close',
    'Other Party: Failure to Yield': 'Other Party: Failure to Yield',
    'Other Party: DUI Alcohol / Drugs/ Medication': 'Other Party: DUI Alcohol / Drugs/ Medication',
    'Other Party: Road Rage Attack': 'Other Party: Road Rage Attack',
    'Vehicle Failure: Tires / Brakes / Clutch / Other': 'Vehicle Failure: Tires / Brakes / Clutch / Other',
    'Act of Nature': 'Act of Nature',
    'Cause not identified': 'Cause not identified',

    Motorway: 'Motorway',
    'Country / Rural': 'Country / Rural',
    'Town / City': 'Town / City',
    Residential: 'Residential',
    'Off-Road': 'Off-Road',
    Other: 'Other',

    Day: 'Day',
    Dawn: 'Dawn',
    Dusk: 'Dusk',
    'Night (With Lighting)': 'Night (With Lighting)',
    'Night (No Lighting)': 'Night (No Lighting)',

    'Fine / Clear': 'Fine / Clear',
    'Bright Sun': 'Bright Sun',
    'Dull / Overcast': 'Dull / Overcast',
    'Fog / Mist': 'Fog / Mist',
    'Hail / Sleet': 'Hail / Sleet',
    'Light Rain': 'Light Rain',
    'Heavy Rain': 'Heavy Rain',
    'Light Snow': 'Light Snow',
    'Heavy Snow': 'Heavy Snow',
    Ice: 'Ice',
    'Light Wind': 'Light Wind',
    'Strong Wind': 'Strong Wind',
    'Hurricane / Tornado': 'Hurricane / Tornado',
    Flood: 'Flood',
    Earthquake: 'Earthquake',

    Excellent: 'Excellent',
    Good: 'Good',
    Satisfactory: 'Satisfactory',
    Poor: 'Poor',
    Dangerous: 'Dangerous',
    'Under Construction': 'Under Construction',

    Congested: 'Congested',
    Flowing: 'Flowing',
    Normal: 'Normal',
    Light: 'Light',

    Airport: 'Airport',
    Driveway: 'Driveway',
    Junction: 'Junction',
    'Car Park': 'Car Park',
    'Retail Park': 'Retail Park',
    'Road / Street': 'Road / Street',
    Roundabout: 'Roundabout',

    Forward: 'Forward',
    Reverse: 'Reverse',
    Stationary: 'Stationary',
    Parked: 'Parked',

    Accelerating: 'Accelerating',
    Braking: 'Braking',
    'Changing Lanes': 'Changing Lanes',
    Reversing: 'Reversing',
    Parking: 'Parking',
    'Overtaking / Being Overtaken': 'Overtaking / Being Overtaken',
    Turning: 'Turning',
    'U-Turn': 'U-Turn',

    'To / From Work': 'To / From Work',
    Work: 'Work',
    Personal: 'Personal',

    '0 - 1 hr': '0 - 1 hr',
    '1 - 2 hr': '1 - 2 hr',
    '2 - 3 hr': '2 - 3 hr',
    '3 - 4 hr': '3 - 4 hr',
    '4+ hrs': '4+ hrs',

    Fatigued: 'Fatigued',
    Aggressive: 'Aggressive',
    'Under the influence of alcohol or drugs': 'Under the influence of alcohol or drugs',
    Distracted: 'Distracted',

    Speeding: 'Speeding',
    'Crash / Collision / Incident': 'Crash / Collision / Incident',
    'Licence Violation': 'Licence Violation',
    'Near Miss': 'Near Miss',

    notAvailable: 'Not Available',
    weeklyFicoLessThan500: 'Weekly FICO Safe Driving Score <500',
    weeklyFicoLessThan559: 'Weekly FICO Safe Driving Score <559',
    ficoSafeScoreBetween560And709:
      'Any Driver who had a FICO® Safe Driving Score between 560-709 for each of the last two weeks',
    driverIndexCoachCoachingReason: 'Low FICO® Safe Driving Score',
    pccCoachingReason: 'Collision',
    driverIndexProCoachingReason: 'Low FICO® Safe Driving Score and had a Collision or Licence Event',
    overall: 'overall',
    noValue: 'No value',
    coachAutoAssign: 'Coach Auto Assign',
    coachingApiService: 'Coaching API Service',

    private: 'Private',
    company_pool_or_utility: 'Company pool or utility',
    company_hire_or_rental: 'Company hire or rental',
    company_owned_or_leased: 'Company owned or leased',
    tool_of_trade: 'Tool of trade',
    benefit_vehicle: 'Benefit vehicle',
    benefit_cash: 'Benefit cash',

    pfz_isa_ins_type1: 'Company Insured (covers personal and use of vehicle for commercial purposes e.g. sales)',
    pfz_isa_ins_type2: 'Personally Insured for Commercial Purposes',
    pfz_isa_ins_type3: 'Personally Insured for Occasional Business Use',
    pfz_isa_ins_type4:
      'Occasional Use (personally insured for occasional business use)Personally Insured but no coverage for business/ commercial purposes',
  },
  courses: {
    Attitude: 'Attitude',
    'Avoiding Damage': 'Avoiding Damage',
    'Bad Weather': 'Bad Weather',
    'Blind Spots': 'Blind Spots',
    'Eco Driving': 'Eco Driving',
    'Driver Fatigue': 'Driver Fatigue',
    Speed: 'Speed',
    '10 - 4 Defense': '10 - 4 Defense',
    'Act Now': 'Act Now',
    'Avoiding Rear End Collisions': 'Avoiding Rear End Collisions',
    Concentration: 'Concentration',
    'Driving Under the Influence': 'Driving Under the Influence',
    'Controlling Emotions': 'Controlling Emotions',
    'Hazard Recognition': 'Hazard Recognition',
    'Sharing the Road': 'Sharing the Road',
    'Lane Changes': 'Lane Changes',
    'General Warehouse Safety': 'General Warehouse Safety',
    'Rural Road Safety': 'Rural Road Safety',
    Behavior: 'Behavior',
    'Decision Making': 'Decision Making',
    'Driver Ergonomics': 'Driver Ergonomics',
    Zero: 'Zero',
    'Driver Wellbeing': 'Driver Wellbeing',
    'Road Rage': 'Road Rage',
    'Vehicle Inspections': 'Vehicle Inspections',
    'Hours of Service (Truck)': 'Hours of Service (Truck)',
    'Driving While Distracted (Truck)': 'Driving While Distracted',
    'Powered Industrial Truck – Pre-Shift Inspections': 'Powered Industrial Truck – Pre-Shift Inspections',
    'Eco Driving (Truck)': 'Eco Driving (Truck)',
    'RC LiftGate': 'RC LiftGate',
    'Bad Weather (Truck)': 'Bad Weather (Truck)',
    'Blind Spots (Truck)': 'Blind Spots (Truck)',
    'Low Speed (Truck)': 'Low Speed (Truck)',
    'Two Wheels': 'Two Wheels',
    'Stability Triangle (Lift Truck)': 'Stability Triangle (Lift Truck)',
    'Knowledge (Lift Truck)': 'Knowledge (Lift Truck)',
    'Harsh Braking': 'Harsh Braking',
    'Harsh Acceleration': 'Harsh Acceleration',
    'Inexperienced Drivers': 'Inexperienced Drivers',
    'Red Mist': 'Red Mist',
    'SN11- Motor Vehicle Safety': 'SN11- Motor Vehicle Safety',
    'Driving While Distracted': 'Driving While Distracted',
    'GSK (Two Wheels)': 'GSK (Two Wheels)',
    'Johnson & Johnson SAFE FLEET 20th ANNIVERSARY': 'Johnson & Johnson SAFE FLEET 20th ANNIVERSARY',
    'Road Warrior': 'Road Warrior',
    'Slips Trips Falls and Ergonomic Injuries': 'Slips Trips Falls and Ergonomic Injuries',
    'Vehicle Checks': 'Vehicle Checks',
    'Self Awareness': 'Self Awareness',
    'Off-Road': 'Off-Road',
    'Sharing the Road (Two Wheels)': 'Sharing the Road (Two Wheels)',
    'Riding in Fog': 'Riding in Fog',
    'Attitude (Truck)': 'Attitude (Truck)',
    'Driver Fatigue (Truck)': 'Driver Fatigue (Truck)',
    'Lights and Tires (Truck)': 'Lights and Tires (Truck)',
    'Nestle Driver Ergonomics': 'Nestle Driver Ergonomics',
    'Speed (Truck)': 'Speed (Truck)',
    'Sever Injury Prevention': 'Sever Injury Prevention',
    'Driver Fatigue HOD (Home Office Delivery)': 'Driver Fatigue HOD (Home Office Delivery)',
    'GSK (Driving While Distracted)': 'GSK (Driving While Distracted)',
    'Mission Zero 2018': 'Mission Zero 2018',
    'Risk Foundation': 'Risk Foundation',
    'Driver Distraction #1': 'Driver Distraction #1',
    'Driver Distraction #2': 'Driver Distraction #2',
    'Driver Distraction #3': 'Driver Distraction #3',
    'Driver Distraction #4': 'Driver Distraction #4',
    'Driver Distraction #5': 'Driver Distraction #5',
    'Driver Distraction #6': 'Driver Distraction #6',
    'Driver Distraction #7': 'Driver Distraction #7',
    'Avoiding Damage (Truck)': 'Avoiding Damage (Truck)',
    'Defensive Driving': 'Defensive Driving',
    'Defensive driving': 'Defensive Driving',
    Profile: 'Profile',
    Suddenly: 'Suddenly',
    ABS: 'ABS',
    'JJ Global Road Safety Briefing': 'JJ Global Road Safety Briefing',
    'PFZ Risk Foundation': 'PFZ Risk Foundation',
    'OSHA (Truck)': 'OSHA (Truck)',
    'Roadside Inspections (Truck)': 'Roadside Inspections (Truck)',
    'Fifth Wheel (Truck)': 'Fifth Wheel (Truck)',
    'Standardized Work Methods (Truck)': 'Standardized Work Methods (Truck)',

    private: 'Private',
    company_pool_or_utility: 'Company pool or utility',
    company_hire_or_rental: 'Company hire or rental',
    company_owned_or_leased: 'Company owned or leased',
    tool_of_trade: 'Tool of trade',
    benefit_vehicle: 'Benefit vehicle',
    benefit_cash: 'Benefit cash',
  },
  guideFaq: {
    managerGuides: 'Manager Guides FAQ',
    companyGuides: 'Company Guides FAQ',
    vrmGuides: 'VRM Guides FAQ',
  },
  mainSidenav: {
    dashboard: 'Dashboard',
    profileInsights: 'Profile Insights',
    contactUs: 'Contact Us',
    defensiveDriving: 'Defensive Driving',
    analytics: 'Analytics',
    driverImport: 'Driver Import',
  },
  orderMvr: {
    pleaseVerifyDriverHas: 'Please verify the driver has',
    sendAlert: 'Yes, send me alerts.',
    dontSendAlert: 'No, do not send me alerts.',
    emailAlert: 'Email Alert',
    mvrAlertNote:
      'if you said yes for an email alert, you will get an alert when the order is placed and another when the MVR is returned',
    mvrSubmitNote:
      'By clicking the button above, an MVR will be ordered using the above details and a charge will be made. The MVR will be logged into the system as ordered by',
    emailConfirmation: 'Email Confirmation',
    orderMvr: 'Order Mvr',
    orderMvrNow: 'Order MVR now',
    missingMvrLicense: 'No License Number',
    licenseState: 'License State',
    licenceNumber: 'Licence Number',
    driverProvidedMvr: 'Driver Provided MVR',
    stateOfferMultipleReports:
      'This state offers multiple types of MVR report, please select the appropriate option below.',
    important: 'Important',
    unsureOfTypeReportHint:
      'If you are unsure as to which report you require, please leave the default option selected.',
    driverNotFound: 'Driver not found',
    missingRequiredFields: 'Missing required Fields',
    statusInvalid: 'MVR Status Invalid',
    licenseInvalid: 'License Invalid',
    duplicateOrder: 'Duplicate Order',
    consentInvalid: 'Consent Invalid',
    invalidReportType: 'Invalid report type',
    lastChecked: 'This driver was last checked on',
    contactToReorder: 'If you would still like to re-order an MVR for this driver please contact us at:',
    overrideReorderInfo:
      'Please check the override option below if you still wish to re-order this MVR (duplicate charges apply).',
    dupExpiryInfo:
      'By default, the system allows one order per driver within a {{expiryDays}} day period. This prevents MVR orders being placed which would otherwise result in duplicate charges.',
    overrideCheckboxLabel: 'I wish to override the duplicate checking on this driver and re-order an MVR.',
  },

  alerts: {
    resolveAlert: 'Resolve Alert',
    resolveDate: 'Alert Resolved Date',
    resolveBy: 'Alert Resolved By',
    acknowledgement:
      'To complete this mandatory action, select the "Alert Resolved" tickbox and enter details of the action taken and then click "Update" button.',
    alertResolved: 'Alert Resolved',
    actionsTaken: 'Actions Taken',
    alertDetail: 'Alert Detail',
    actionsTakenError: 'Actions Taken comments must be min:1 and max:250 characters',
    actionsTakenEmpty: 'Actions Taken input field cannot be empty',
    leaveAsUnresolved: 'If you wish to leave as unresolved for now, simply close this tab to return to the main page',
  },
  userCsv: {
    firstName: 'First Name*',
    lastName: 'Last Name*',
    middleName: 'Middle Name',
    email: 'Email*',
    phoneNumber: 'Phone Number (Optional)',
    driverGroupId: 'Station Assignment* (only 1 per driver)',
    managerGroupIds: 'Managed Station(s) If user is a manager - enter stations they manage separated by a space',
  },
  licenceChecking: {
    driverDetails: 'Driver Details',
    employeeNumber: 'Employee Number',
    licenceLastChecked: 'Licence Last Checked',
    mandateValidUntil: 'Mandate Valid Until',
    licenceIssueNumber: 'Licence Issue Number',
    licenceType: 'Licence Type',
    licenceExpiry: 'Licence Expiry',
    licenceExpires: 'Licence Expire',
    licenceCategory: 'Licence Category',
    commenceDate: 'Commence Date',
    expiryDate: 'Expiry Date',
    identifier: 'Identifier',
    restrictionCodesExplained: 'Restriction Codes Explained',
    restrictionCodes: 'Restriction Codes',
    endorsements: 'Endorsements',
    offenceDate: 'Offence Date',
    offenceCode: 'Offence Code',
    points: 'Points',
    convictionDate: 'Conviction Date',
    disqualEndDate: 'Disqualification End Date',
    code: 'Code',
    licenceClass: 'License Class',
    dateIssued: 'Date Issued',
    dateExpires: 'Date Expires',
    restrictions: 'Restrictions',
    status: 'Status',
    commercialStatus: 'Commercial Status',
    eventDate: 'Event Date',
    A1: 'A motorcycle with a cylinder capacity not exceeding 125cc, of a power not exceeding 11kW and with a power to weight ratio not exceeding 0.1kW per kg. A motor tricycle with a power not exceeding 15kW.',
    A: 'A motorcycle of a power exceeding 35kW or with a power to weight ratio exceeding 0.2kW per kg, or A motorcycle of a power not exceeding 35kW with a power to weight ratio not exceeding 0.2kW per kg and derived from a vehicle of more than double its power.',
    B1: 'Motor vehicles with four wheels up to 400kg unladen weight or 550kg for vehicles intended for carrying goods.',
    B: 'Motor vehicles with a MAM not exceeding 3500kg having not more than 8 passenger seats with a trailer up to 750kg. Combinations of towing vehicles in category B and a trailer, where the MAM of the combination does not exceed 3500kg and the MAM of the trailer does not exceed the unladen mass of the towing vehicle.',
    'B Automatic': 'As cars, but with automatic transmission.',
    BE: 'Combinations of vehicles consisting of a vehicle in category B and a trailer, where the combination does not come within category B, and the MAM of the trailer or semi-trailer does not exceed 3500kg.',
    C1: 'Vehicles between 3500kg and 7500kg, and designed and constructed for the carriage of no more than eight passengers in addition to the driver with a trailer up to 750kg.',
    C1E: 'Vehicles between 3500kg and 7500kg with a trailer over 750kg and designed and constructed for the carriage of no more than eight passengers in addition to the driver – combined weight not more than 12000kg.',
    C: 'Vehicles over 3500kg with a trailer up to 750kg.',
    CE: 'Vehicles over 3500kg and designed and constructed for the carriage of no more than eight passengers in addition to the driver with a trailer over 750kg.',
    D1: 'Vehicles with no more than 16 passenger seats in addition to the driver and with a maximum length not exceeding eight metres with a trailer up to 750kg.',
    D1E: 'Vehicles with no more than 16 passenger seats in addition to the driver and with a maximum length not exceeding 8 metres with a trailer over 750kg, provided that the MAM of the combination formed does not exceed 12000kg.',
    D: 'Any bus designed and constructed for the carriage of more than eight passengers in addition to the driver, with a trailer up to 750kg.',
    DE: 'Any bus designed and constructed for the carriage of more than eight passengers in addition to the driver, with a trailer over 750kg.',
    F: 'Agricultural tractors',
    G: 'Road Rollers',
    H: 'Tracked Vehicles',
    K: 'Mowing machine or vehicle controlled by a pedestrian',
    L: 'Electric vehicles',
    N: 'Vehicles used for very short distances on public roads',
    P: 'Motor vehicles with fewer than four wheels with a maximum design speed exceeding 45km/h but not exceeding 50km/h and which, if propelled by an internal combustion engine, has a cylinder capacity not exceeding 50cc.',
    AM: 'Moped - Two-wheel vehicles or three-wheel vehicles with a maximum design speed of over 25km/h and not more than 45km/h. Light quadricycle - With an unladen mass of not more than 350kg, not including the mass of the batteries in the case of electric vehicles, whose maximum design speed is over 25km/h and not more than 45km/h.',
    A2: 'A motorcycle of a power not exceeding 35kW, with a power to weight ratio not exceeding 0.2kW per kg and not derived from a vehicle of more than double its power.',
    Q: 'Motor vehicles with fewer than four wheels which, if propelled by an internal combustion engine, has a cylinder capacity not exceeding 50cc and, if not equipped with pedals by means of which the vehicle is capable of being propelled, has a maximum desig',
    FC: 'Current Full Licence',
    PC: 'Current Provisional Licence',
    FE: 'Expired Full Licence',
    PE: 'Expired Provisional Licence',
    FS: 'Surrendered Full Licence',
    PS: 'Surrendered Provisional Licence',
    DQ: 'Disqualified',
    DD: 'Disqualified until a given date',
    DT: 'Disqualified until a test is passed',
    DS: 'Disqualified until sentenced, including awaiting sentence or review of sentencing',
    DX: 'Disqualified for life',
    RV: 'Revoked until test passed',
    NE: 'No current GB entitlement held',
  },
  tachographStatus: {
    cardStatus: 'Card status',
    code11: 'Valid',
    code12: 'Invalid',
    code13: 'Invalid',
    code14: 'Invalid',
    code15: 'Lost',
    code16: 'Stolen',
    code17: 'Malfunctioning',
    code18: 'Invalid',
    code19: 'Invalid',
    code20: 'Invalid',
    code21: 'Invalid',
    code27: 'Damaged',
    code29: 'Invalid, no GB tachograph on this record',
    code30: 'Valid',
  },
  customReport: {
    noDataReceivedCustomCSV: `The report you requested did not return any results`,
  },
  navigationFilter: {
    'RoadRISK: PROFILE: RIDER': 'RoadRISK: PROFILE: RIDER',
    'RoadRISK: PROFILE: JOURNEY': 'RoadRISK: PROFILE: JOURNEY',
    'RoadRISK: PROFILE: VEHICLE': 'RoadRISK: PROFILE: VEHICLE',
    'RoadRISK: DEFENSIVE DRIVING': 'RoadRISK: DEFENSIVE DRIVING',
    'RoadRISK: RATING': 'RoadRISK: RATING',
    'RoadRISK: PROFILE: DRIVER': 'RoadRISK: PROFILE: DRIVER',
    'RoadRISK: PROFILE: OPERATOR': 'RoadRISK: PROFILE: OPERATOR',
    Car: 'Car',
    'Multi-drop': 'Multi-drop',
    Truck: 'Truck',
    'Two Wheeler': 'Two Wheeler',
    PIV: 'PIV',
    All: 'All',
    Type: 'Type',
    Location: 'Location',
    Report: 'Report',
  },
  customTooltips: {
    ACCIDENT: 'ACCIDENT',
    'Event Date': 'Date de l`événement',
    'Conviction Date': 'Date de condamnation',
  },

  login: {
    systemName: 'Management Information System',
    loginFormTitle: 'Sign In',
    emailLabel: 'Email',
    companyLabel: 'Company',
    passwordLabel: 'Password',
    confirmNewPassword: 'Confirm new password',
    newPassword: 'New password',
    passwordStrength: 'Password strength',
    signInButton: 'Sign In',
    backToSignIn: 'Back to Sign In',
    requestPasswordReset: 'Request Password Reset',
    clearButton: 'Clear',
    piiDisclaimerLine1: 'Virtual Risk Manager contains Personally Identifiable Information (PII)',
    piiDisclaimerLine2:
      'Any information we hold on you within our systems will NOT be used to send unsolicited e-mail and will not be sold to a 3rd party.',
    allRightsReserved: 'All rights reserved',
    username: 'Username',
    resetPassword: 'Reset Password',
    notification: `We've simplified our login process!`,
    loginHelp: 'Having trouble logging in?',
    loginHelpTitle: 'Login Issues?',
    loginHelpExistingClient: 'Please reach out using your support email or click here to request support: ',
    loginHelpLink: 'Existing Client Support',
    loginHelpAmazonDsp: 'Amazon DSPs?',
    loginHelpAmazon: 'Please click here to request support: ',
    loginHelpAmazonLink: 'Amazon DSP Support',
  },
  security: {
    v2TokenLogOn: 'V2 User Sign On',
    v2TokenLoginFailed: 'V2 User Sign On, please close this page and retry the process',
    security: 'Security',
    account: 'Account',
    accountAndSecurity: 'Account and Security',
    companyInUse: 'Company In Use',
    warning: 'Warning',
    timeout: 'Timeout',
    closeTimeoutWarning: 'Close Timeout Warning',
    resetPassword: 'Reset Password',
    changePassword: 'Change Password',
    switchCompany: 'Switch Company',
    youWillBeSignedOutIn: 'You will be signed out in',
    singleSignOn: 'Single Sign On',
    ssoLoginFailed: 'SSO Login Failed, please close this page and retry the process',
    ssoLoggedOutMessage: 'You are not logged in',
    passwords: 'Passwords',
    passwordRequirements: 'Password Requirements',
    mustContainA: 'Must contain a',
    minimumLength: 'Minimum length',
    maximumLength: 'Maximum length',
    number: 'Number',
    lowercaseCharacter: 'Lowercase character',
    uppercaseCharacter: 'Uppercase character',
    specialCharacter: 'Special character',
    mustNotContainUsername: 'Must not contain your Username',
    mustNotBeLastPassword: 'Must not be your last Password',
    mustNotBeOneOfYourLast: 'Must not be one of your last',
    cannotBeChangedUntilOneHourLater: 'Cannot be changed until 1 hour after last change',
    cannotBeResetUntil: 'Cannot be reset until',
    hoursAfterLastChange: 'Hours after last change',
    weak: 'Weak',
    medium: 'Medium',
    strong: 'Strong',
    veryStrong: 'Very Strong',
  },
  dashboardFilters: {
    'Display Distance In': 'Display Distance In',
    'This Period Date Range': 'This Period Date Range',
    Miles: 'Miles',
    Kilometres: 'Kilometres',
    'Last 4 Weeks': 'Last 4 Weeks',
    'Last 3 Months': 'Last 3 Months',
    'Last 6 Months': 'Last 6 Months',
  },
};
